/**
 * 过滤掉条件对象中value为空字符串的条件项
 *
 * @param obj
 * @example
 *
 * filterConditions({a: '', b: 1})
 * // {b: 1}
 */
function filterConditions(obj: any = {}) {
  if (typeof obj !== 'object' || !obj) return obj;

  const res: any = {};

  const keys = Object.keys(obj);

  for (var i = 0, len = keys.length; i < len; i++) {
    if (
      obj[keys[i]] == null ||
      obj[keys[i]] === '' ||
      // 存在值 [] 的情况，但是对于{}则无能为力
      obj[keys[i]].toString() === ''
    )
      continue;

    res[keys[i]] = obj[keys[i]];
  }

  return res;
}

/**
 * 和filterConditions做的事情一样
 * @param conditions
 */
function formatConditionsToQuery(conditions: any) {
  const res: any = {};
  Object.keys(conditions).forEach((key) => {
    if (conditions[key] !== '') res[key] = conditions[key];
  });
  return res;
}

function downloadFile(url: string) {
  if (!url) return;

  if (url.indexOf('https:') === 0) {
    window.location.href = url.replace('https:', ''); //replace方法只会替换匹配到的第一个
    return;
  }
  if (url.indexOf('http:') === 0) {
    window.location.href = url.replace('http:', '');
    return;
  }
  window.location.href = url;
}

/**
 * 根据参数格式化一个完整的url
 *
 * @param param0
 * @example
 *
 * formatUrl('http', 'jd.com', undefined, '/a/b', {a: 1}, 'a')
 * // 'http://jd.com/a/b?a=1#a'
 */
function formatUrl({ scheme = '', domain = '', port = '', pathname = '', params = {}, hash = '' } = {}) {
  let url = '';

  if (scheme) {
    url += scheme + '://';
  }

  if (domain) {
    url += domain;
  }

  if (port) {
    url += ':' + port;
  }

  if (pathname) {
    url += pathname;
  }

  if (<any>params) {
    url += '?';
    for (var key in <any>params) {
      url += key + '=' + (<any>params)[key] + '&';
    }
    url = url.slice(0, url.length - 1);
  }
  if (hash) {
    url += '#' + hash;
  }

  return url;
}

/**
 * 将查询对象格式化成字符串
 *
 * @param obj
 * @example
 *
 * formatQueryObj({a: 1, b: 2})
 * // 'a=1&b=2'
 */
function formatQueryObj(obj: any = {}) {
  const res = Object.keys(obj).reduce((prev, cur) => {
    return `${prev}${encodeURIComponent(cur)}=${encodeURIComponent(obj[cur])}&`;
  }, '');

  return res.length ? res.slice(0, res.length - 1) : res;
}

function parseQuery(querystring: string): { [index: string]: string } {
  if (!querystring) return {};
  if (querystring[0] === '?') querystring = querystring.slice(1);

  return querystring.split('&').reduce<{ [index: string]: string }>(function (prev, cur) {
    const keyandvalue = cur.split('=');
    prev[keyandvalue[0]] = decodeURIComponent(keyandvalue[1]);
    return prev;
  }, {});
}

/**
 * 将查询对象格式化成字符串
 * 接受严格模式，严格模式下，键值为null/undefined/''/'null'/'undefined'将不被参与计算
 * @param (obj,mode=false )
 * @example
 *
 * formatQueryObj({a:null, b: 2},false)
 * // 'a=null&b=2'
 *
 * formatQueryObj({a:null, b: 2},true)
 * // 'b=2'
 */
function formatQueryObjNew(obj: any = {}, mode: boolean = false) {
  const res = Object.keys(obj)?.reduce((prev, cur) => {
    if (mode) {
      return (obj[cur] ?? '') === '' || obj[cur] === 'null' || obj[cur] === 'undefined'
        ? `${prev}`
        : `${prev}${encodeURIComponent(cur)}=${encodeURIComponent(obj[cur])}&`;
    } else {
      return `${prev}${encodeURIComponent(cur)}=${encodeURIComponent(obj[cur])}&`;
    }
  }, '');

  return res.length ? (res.endsWith('&') ? res.slice(0, res.length - 1) : res) : res;
}

function pushQuery(link: string, query: string) {
  const [key, value] = query.split('=');
  if (!value) return link;
  if (link.indexOf('?') === -1) return `${link}?${query}`;
  if (link.indexOf(key) === -1) return `${link}&${query}`;
  return link;
}

export {
  filterConditions,
  formatConditionsToQuery,
  formatUrl,
  formatQueryObj,
  downloadFile,
  parseQuery,
  formatQueryObjNew,
  pushQuery,
};
